import { ArrowRightIcon } from "./Icons";

const services = [
  {
    number: "01",
    title: "3D Printing",
    copy: "Cetak prototipe, komponen, miniatur, dan produk custom dengan hasil presisi.",
  },
  {
    number: "02",
    title: "3D Design",
    copy: "Pemodelan 3D dari sketsa, referensi, atau kebutuhan teknis.",
  },
  {
    number: "03",
    title: "Rapid Prototyping",
    copy: "Uji bentuk dan fungsi lebih cepat sebelum masuk ke produksi.",
  },
  {
    number: "04",
    title: "Finishing",
    copy: "Sanding, assembly, dan pewarnaan untuk hasil yang siap tampil.",
  },
] as const;

export function Services() {
  return (
    <section className="services section-light" id="layanan" aria-labelledby="services-title">
      <div className="container">
        <div className="section-intro services-intro" data-reveal>
          <h2 id="services-title">
            <span>Layanan yang</span>
            <span>membuat ide bergerak.</span>
          </h2>
          <div>
            <p>Dari file mentah sampai produk siap dipresentasikan, kami membantu di setiap tahap.</p>
            <a className="button button-primary service-cta" href="#order">
              Bahas kebutuhanmu
              <ArrowRightIcon />
            </a>
          </div>
        </div>

        <div className="services-body" data-reveal>
          <div className="service-list">
            {services.map((service) => (
              <article className="service-row" key={service.number}>
                <span className="service-number" aria-hidden="true">{service.number}</span>
                <h3>{service.title}</h3>
                <p>{service.copy}</p>
                <span className="service-mark" aria-hidden="true" />
              </article>
            ))}
          </div>
          <figure className="services-media">
            <img
              alt="Detail objek hasil 3D printing di meja kerja Morolab"
              height="1024"
              loading="lazy"
              src="/images/hero-studio.webp"
              width="1536"
            />
          </figure>
        </div>
      </div>
    </section>
  );
}
